









import Vue from "vue";
import { Component } from "vue-property-decorator";
import JinroGameHistoryDetail from "@/components/shared/JinroGameHistoryDetail/JinroGameHistoryDetail.vue";

@Component({
  components: {
    JinroGameHistoryDetail,
  },
})
export default class JinroGameHistory extends Vue {
  get jinroGameId(): string {
    return this.$route.params.jinroGameId;
  }
}
